<template>
  <!------------- See Profile Section --------------->
  <v-card flat>
    <!------------- Start Back Button Section --------------->
    <v-card flat class="d-flex justify-end">
      <router-link to="/users" style="text-decoration: none">
        <v-btn depressed color="transparent" class="d-flex justify-end">
          Back
        </v-btn>
      </router-link>
    </v-card>
    <!------------- End Back Button Setion --------------->

    <v-card color="transparent" flat>
      <!------------- Profile Section --------------->
      <div>
        <template v-for="item in items">
          <div class="d-flex justify-start mb-6" :key="item.title">
            <v-card
              style="width: 17.7vw; padding: 1%"
              flat
              v-if="IsEditing"
              color="transparent"
            >
              <userimageuploaderComponent
                :img="GetPreviewUser?.ProfileImage"
                @setImage="SetImage"
              ></userimageuploaderComponent>
            </v-card>
            <div v-else>
              <v-avatar v-if="GetPreviewUser?.ProfileImage" size="150" style=" overflow: hidden; background-color: transparent;">
                <img 
                  :src="GetPreviewUser?.ProfileImage" 
                  @error="setDefaultImage" 
                  style="width: 100%; height: 100%; object-fit: cover; object-position: center;background-color: white;"
                />
              </v-avatar>
              <v-avatar v-else size="150" style=" overflow: hidden; background-color: transparent;">
                <img
                  src="https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png"
                  style="width: 100%; height: 100%; object-fit: cover; object-position: center;background-color: white;"
                />
                <!-- src="../../../src/assets/images/profile-iba-fallback.jpg" -->
              </v-avatar>
            </div>
            <div class="mt-10 px-10">
              <div class="profile_h1">
                {{ GetPreviewUser?.FirstName }} {{ GetPreviewUser?.LastName }}
              </div>
              <div class="profile_span">
                {{ GetPreviewUser?.Email }}
              </div>
            </div>
          </div>
        </template>
      </div>
      <!------------- End Profile --------------->
      <div>
        <!------------- Start Tabs  --------------->

        <v-tabs
          flat
          v-model="tabs"
          class="tabs_slider"
          style="text-transform: none !important; flex: 0px"
        >
          <v-tab style="text-transform: none !important" class=""
            ><b>Profile</b></v-tab
          >
          <v-tab style="text-transform: none !important"
            ><b>Membership</b></v-tab
          >
          <v-tab style="text-transform: none !important"
            ><b>Purchases & Billing</b></v-tab
          >
          <v-tab style="text-transform: none !important" v-if="GetPreviewUser?.ExamsCredentials.includes(1)"><b>CEUs</b></v-tab>
          <v-tab style="text-transform: none !important"
            ><b>Courses Taken</b></v-tab
          >

          <v-tab style="text-transform: none !important"
            ><b>Exams & Credentials</b></v-tab
          >
          <v-tab style="text-transform: none !important"
            ><b>Courses Taught</b></v-tab
          >
          <v-tab style="text-transform: none !important"><b>Notes</b></v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <div class="mt-10 d-flex justify-space-between heading-2">
                Profile settings
                <div>
                  <v-btn
                    rounded
                    outlined
                    v-if="!IsEditing"
                    color="#1884CD"
                    class="px-9"
                    dark
                    style="
                      text-transform: none !important;
                      border: 1px solid #d2e5fc;
                    "
                    @click="IsEditing = true"
                    >Edit
                  </v-btn>
                  <v-btn
                    rounded
                    outlined
                    v-if="IsEditing"
                    color="green"
                    class="px-9"
                    dark
                    style="
                      text-transform: none !important;

                      border: 1px solid #d2e5fc;
                    "
                    @click="Update"
                    >Update
                  </v-btn>
                  <v-btn
                    rounded
                    outlined
                    v-if="IsEditing"
                    color="red"
                    class="px-9 ml-3"
                    dark
                    style="
                      text-transform: none !important;
                      border: 1px solid red;
                    "
                    @click="cancelprofile()"
                    >Cancel
                  </v-btn>
                </div>
              </div>
            </v-card>
            <!------------- start Presonal Information  --------------->

            <v-card flat>
              <v-row class="mt-1">
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div><span class="style_txt_hh1">First name</span></div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2" v-if="!IsEditing">{{
                          GetPreviewUser?.FirstName
                        }}</span>
                        <v-text-field
                          v-if="IsEditing"
                          single-line
                          dense
                          v-model="GetPreviewUser.FirstName"
                          :error-messages="
                            getErrorMessage('FirstName', 'FirstName')
                          "
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="4">
                      <div>
                        <span class="style_txt_hh1">Display Language</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="8">
                      <div>
                        <span class="style_txt_hh2" v-if="!IsEditing">{{
                          GetPreviewUser?.Language
                        }}</span>
                        <v-autocomplete
                          v-if="IsEditing"
                          single-line
                          :items="LanguageArray"
                          dense
                          v-model="GetPreviewUser.Language"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="mt-1">
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div><span class="style_txt_hh1">Last name</span></div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2" v-if="!IsEditing">{{
                          GetPreviewUser?.LastName
                        }}</span>
                        <v-text-field
                          v-if="IsEditing"
                          single-line
                          dense
                          v-model="GetPreviewUser.LastName"
                          :error-messages="
                            getErrorMessage('LastName', 'LastName')
                          "
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div><span class="style_txt_hh1">Time Zone</span></div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2" v-if="!IsEditing">{{
                          GetPreviewUser?.Timezone
                        }}</span>

                        <v-autocomplete
                          v-if="IsEditing"
                          single-line
                          :items="AllTimeZone"
                          :filter="customFilter"
                          item-text="name"
                          item-value="timezone"
                          dense
                          v-model="GetPreviewUser.Timezone"
                        >
                        </v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div><span class="style_txt_hh1">Alternate name</span></div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2" v-if="!IsEditing">{{
                          GetPreviewUser?.AlternateName
                        }}</span>
                        <v-text-field
                          v-if="IsEditing"
                          single-line
                          dense
                          v-model="GetPreviewUser.AlternateName"
                          
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div class="mr-9">
                    <span class="style_txt_hh1"
                      >Linked to PaRama Campus account</span
                    >
                  </div>
                  <span class="style_txt_hh2">
                    {{ GetPreviewUser?.LinkToParama ? "Yes" : "No" }}
                  </span>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div>
                        <span class="style_txt_hh1">Email</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2" v-if="!IsEditing">{{
                          GetPreviewUser?.Email
                        }}</span>
                        <v-text-field
                          v-if="IsEditing"
                          single-line
                          dense
                          v-model="GetPreviewUser.Email"
                          :error-messages="getErrorMessage('Email', 'Email')"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div class="mr-9">
                    <span class="style_txt_hh1"
                      >Signed Coordinator Agreement</span
                    >
                  </div>
                  <span class="style_txt_hh2">{{
                    GetPreviewUser?.SignedCoordinatorAgreement ? "Yes" : "No"
                  }}</span>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div>
                        <span class="style_txt_hh1">Phone Number</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2" v-if="!IsEditing">{{
                          GetPreviewUser?.Phone
                        }}</span>
                        <v-text-field
                          v-if="IsEditing"
                          single-line
                          dense
                          maxlength="17"
                          minlength="7"
                          v-model="GetPreviewUser.Phone"
                          :error-messages="getErrorMessage('Phone', 'Phone')"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div><span class="style_txt_hh1">Country</span></div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2" v-if="!IsEditing">
                          {{ GetPreviewUser?.Country }}
                        </span>
                        <v-autocomplete
                          v-if="IsEditing"
                          single-line
                          dense
                          :items="countryList"
                          v-model="GetPreviewUser.Country"
                        ></v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div>
                        <span class="style_txt_hh1">Date registered</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2">{{
                          GetPreviewUser?.CreatedDate != null &&
                          GetPreviewUser?.CreatedDate != undefined
                            ? GetPreviewUser?.CreatedDate?.split("T")[0]
                            : ""
                        }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div><span class="style_txt_hh1">Membership</span></div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2">
                          <!-- <span v-if="getMembershipByUserId?.MembershipStatus == 4">
                            {{previousMembershipName}}
                          </span>
                          <span v-else>{{ getMembershipByUserId?.Name }}</span> -->
                          <span>{{ getMembershipByUserId?.Name }}</span>
                          
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div><span class="style_txt_hh1">Password</span></div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2">***********</span>
                        <v-icon
                          class="mx-4 mt-n3"
                          color="#52AE32"
                          @click="OpenPasswordDialog()"
                          >mdi-lock</v-icon
                        >
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" md="3">
                      <div><span class="style_txt_hh1">Webpage URL</span></div>
                    </v-col>
                    <v-col cols="12" md="9">
                      <div>
                        <span class="style_txt_hh2" v-if="!IsEditing">{{
                          GetPreviewUser?.WebpageURL
                        }}</span>
                        <v-text-field
                          v-if="IsEditing"
                          single-line
                          dense
                          v-model="GetPreviewUser.WebpageURL"
                        ></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="3" class="d-flex align-center">
                      <div>
                        <span class="style_txt_hh1">Specializations</span>
                      </div>
                    </v-col>
                    <v-col cols="9" class="">
                      <v-chip-group column v-show="!IsEditing">
                        <v-chip
                          v-for="tag in specializationsArray"
                          :key="tag"
                          label
                        >
                          {{ tag }}
                        </v-chip>
                      </v-chip-group>
                      <v-combobox
                        flat
                        v-show="IsEditing"
                        v-model="specializationsArray"
                        :items="specializationsArray"
                        class="pl-0 pr-0"
                        hide-selected
                        label=""
                        multiple
                        small-chips
                        solo
                        style="border: 1px solid #d3caca"
                        append-icon=" "
                      >
                        <template v-slot:selection="{ item, parent }">
                          <v-chip>
                            <span class="pr-2">
                              {{ item }}
                            </span>
                            <v-icon small @click="parent.selectItem(item)"
                              >mdi-close</v-icon
                            >
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div
                class="primary--text mt-7"
                v-if="isValue"
              >
                <span style="text-decoration: underline" class="cursor-pointer" @click="openBioPage()">View bio page</span>
                <!-- @click="viewBioDialog = true" -->
                
              </div>
            </v-card>
            <!------------- End Presonal Information  --------------->
            <v-divider class="my-7 devider_style"> </v-divider>
            <!------------- start Address --------------->
            <v-card flat>
              <div class="mt-10 d-flex justify-space-between heading-2">
                Addresses

                <!------------- start Edit  Dialog --------------->
                <v-dialog v-model="AddNewAddressDialog" width="600" persistent>
                  <template v-slot:activator="{ on, attrs }" class="px-10">
                    <div class="d-flex justify-end">
                      <v-btn
                        rounded
                        outlined
                        color="#1884CD"
                        class="px-9"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        style="
                          text-transform: none !important;
                          border: 1px solid #d2e5fc;
                        "
                        >Add
                      </v-btn>
                    </div>
                  </template>
                  <v-card class="pa-6">
                    <div class="px-4 py-4 d-flex justify-space-between align-center">
                      <span class="h3">Add new address</span>
                      <v-icon @click="closeDialog()">mdi-close</v-icon>
                    </div>
                    <div style="border-left:3px solid #c0c0c0" class="ml-4 pl-2 pr-4">
                      <div><em>Options in each dropdown depend on the selection above. Fields can be left blank but will affect public location filters. "Address" can include your preferred text. Some rural or unique locations may not appear—if you don’t see what you need, email <a href="mailto:office@bodytalksystem.com">office@bodytalksystem.com</a> and we’ll add it.</em></div>
                    </div>
                    <div class="mx-5">
                      <div class="mt-4">
                        
                        <div class="">
                          <b>Street Address</b>
                        </div>
                        <v-text-field
                          dense
                          outlined
                          flat
                          single-line
                          
                          append-icon="mdi-check"
                          class="pt-4"
                          placeholder=""
                          v-model="Addresses.StreetAddress1"
                          :error-messages="
                            $v.Addresses.StreetAddress1.$error
                              ? 'Street address is required'
                              : null
                          "
                        ></v-text-field>
                        <!-- <div class="">
                          <b>Street Address2</b>
                        </div>
                        <v-text-field
                          dense
                          outlined
                          flat
                          single-line
                          disabled
                          append-icon="mdi-check"
                          class="my-2"
                          placeholder=""
                          v-model="Addresses.StreetAddress2"
                        ></v-text-field> -->
                        <v-row class="mt-0">
                          <v-col col="12" md="12" class="py-1">
                            <div class="pb-3">
                              <b class="pb-2">Region</b>
                            </div>
                            <v-autocomplete
                              dense
                              outlined
                              :items="regions"
                              v-model="Addresses.region"
                              attach
                              @change="fetchCountries"
                            />
                          </v-col>
                          <v-col col="12" md="12" class="py-1">
                            <div class="pb-3">
                              <b class="pb-2">Country</b>
                            </div>
                            <v-autocomplete
                              dense
                              outlined
                              attach
                              :items="countries"
                              v-model="Addresses.country"
                              @change="fetchStates"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="mt-0">
                          <v-col col="12" md="12" class="py-1">
                            <div class="pb-3">
                              <b class="pb-2">State / Province</b>
                            </div>
                            <v-autocomplete
                              dense
                              outlined
                              attach
                              :items="states"
                              v-model="Addresses.state"
                              @change="fetchCities"
                            />
                              
                          </v-col>
                          <v-col col="12" md="12" class="py-1">
                            <div class="pb-3">
                              <b>City</b>
                              <div>
                                <div class="text-muted font-italic" style="font-size:14px;">
                                  If your city is not listed, select "Other" and enter your city, municipality, or community name.
                                </div>
                              </div>
                            </div>
                            <v-autocomplete
                              dense
                              outlined
                              attach
                              :items="['Other',...cities]"
                              v-model="Addresses.city"
                            />
                            <v-text-field
                              v-if="Addresses.city === 'Other'"
                              v-model="otherCity"
                              label="Enter your community or muncipality"
                              dense
                              outlined
                            />
                          </v-col>
                        </v-row>
                        
                        <v-row class="mt-0">
                          <v-col col="12" md="12" class="py-1">
                            <div class="pb-3">
                              <b class="pb-2">Zip Code</b>
                            </div>
                            <v-text-field
                              dense
                              outlined
                              placeholder=""
                              v-model="Addresses.zipcode"
                              ></v-text-field>
                          </v-col>
                        </v-row>
                        <div class="pt-3">
                          <p class="">
                            Should the address be visible publicly, YES or NO
                          </p>
                        </div>
                        <div class="mx-3">
                          <b-form-radio
                            v-model="Addresses.IsPublicallyVisible"
                            :value="true"
                            class="mb-2"
                            ><span class="pl-3">Yes</span></b-form-radio
                          >
                          <b-form-radio
                            v-model="Addresses.IsPublicallyVisible"
                            :value="false"
                            ><span class="pl-3">No</span></b-form-radio
                          >
                        </div>
                        <div
                          class="red--text" style="font-size:12px"
                          v-if="$v.Addresses.IsPublicallyVisible.$error"
                        >
                          Must be select one option
                        </div>
                      </div>
                      <div class="mt-6">
                        <p class="">
                          Is this address a clinic address or home address?
                        </p>
                        <div class="mx-3">
                          <b-form-checkbox
                            class="mb-2"
                            v-model="Addresses.IsClinicAddress"
                            :value="true"
                          >
                            <span class="pl-3"> Clinic </span> </b-form-checkbox
                          ><b-form-checkbox
                            v-model="Addresses.IsHomeAddress"
                            :value="true"
                          >
                            <span class="pl-3"> Home</span>
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div class="mt-6">
                        <p class="">Is this your shipping address?</p>
                        <div class="mx-3">
                          <b-form-radio
                            v-model="Addresses.IsShippingAddress"
                            :value="true"
                            class="mb-2"
                            ><span class="pl-3">Yes</span></b-form-radio
                          >
                          <b-form-radio
                            v-model="Addresses.IsShippingAddress"
                            :value="false"
                            ><span class="pl-3">No</span></b-form-radio
                          >
                        </div>
                        <div
                          class="red--text" style="font-size:12px"
                          v-if="$v.Addresses.IsShippingAddress.$error"
                        >
                          Must be select one option
                        </div>
                      </div>
                    </div>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="px-10 py-6"
                        color="#A1A3A8"
                        text
                        @click="closeDialog()"
                        style="text-transform: none"
                      >
                        Cancel
                      </v-btn>

                      <v-btn
                        depressed
                        color="primary"
                        class="px-14 py-6"
                        style="text-transform: none"
                        @click="AddAddress()"
                      >
                        <v-progress-circular
                          indeterminate
                          size="20"
                          class="px-5"
                          color="white"
                          v-if="btnloader"
                        ></v-progress-circular>
                        <span v-else> Save </span>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!------------- End Edit  Dialog --------------->
              </div>
            </v-card>
            <div>
              <div class="mt-8 mb-14">
                <div
                  class="d-flex justify-space-between mt-4 align-center"
                  v-for="(item, i) in GetAllAddresses"
                  :key="i"
                >
                  <div class="d-flex">
                    <v-icon color="black">mdi-map-marker</v-icon>
                    <div class="ml-4">
                      {{ item.StreetAddress1 }}
                    </div>
                  </div>
                  <div>
                    <v-btn depressed color="transparent" icon>
                      <v-icon color="#A1A1A6" @click="EditAddress(item)"
                        >mdi-pencil</v-icon
                      >
                    </v-btn>
                    <v-btn depressed color="transparent" icon class="ml-2">
                      <v-icon color="#F52626" @click="OpenDeleteDialog(item.Id)"
                        >mdi-delete-outline</v-icon
                      >
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
            <!------------- End Address Dialog --------------->

            <!------------- start Exams & Credentials --------------->
            <!-- <v-card flat style="width: 600px">
              <div class="mt-10 d-flex justify-space-between heading-2">
                Exams & Credentials
              </div>
            </v-card>
            <v-card class="mt-6 mb-10" outlined>
              <v-data-table
                :headers="credentialsheaders"
                :items="credentialsDataTable"
                hide-default-footer
              >
                <template v-slot:[`item.date`]="{ item }">
                  <span class="index_span_2_style">
                    {{ item.date }}
                  </span>
                </template>
                <template v-slot:[`item.exam`]="{ item }">
                  <span class="index_span_2_style">
                    {{ item.exam }}
                  </span>
                </template>
                <template v-slot:[`item.instructor`]="{ item }">
                  <span class="index_span_2_style">
                    {{ item.instructor }}
                  </span>
                </template>
                <template v-slot:[`item.writtenscore`]="{ item }">
                  <span class="index_span_2_style">
                    {{ item.writtenscore }}
                  </span>
                </template>
                <template v-slot:[`item.particalscore`]="{ item }">
                  <span class="index_span_2_style">
                    {{ item.particalscore }}
                  </span>
                </template>
                <template v-slot:[`item.credentialearn`]>
                  <span class="index_span_2_style">
                    {{ item.credentialearn }}
                  </span>
                </template>
                <template v-slot:[`item.downlaods`]>
                  <v-icon color="#A1A1A6" class="pa-4"> mdi-download </v-icon>
                </template>

                <template v-slot:[`item.actions`]>
                  <v-menu
                    transition="scroll-y-transition"
                    offset-y
                    color="transparent"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                        mdi-dots-horizontal
                      </v-icon>
                    </template>
                    <v-card flat>
                      <v-list class="px-3 pt-1" color="transparent">
                        <div class="d-flex">
                          <v-btn
                            depressed
                            color="transparent"
                            block
                            class="d-flex justify-start"
                          >
                            <v-icon color="#646464">mdi-pencil</v-icon>
                            <span class="ml-4 text_style">Edit</span>
                          </v-btn>
                        </div>
                      </v-list>
                      <v-list class="px-3 pt-1" color="transparent">
                        <div class="d-flex">
                          <v-btn
                            depressed
                            color="transparent"
                            block
                            class="d-flex justify-start"
                          >
                            <v-icon color="#646464">mdi-delete</v-icon>
                            <span class="ml-4 text_style">Delete </span>
                          </v-btn>
                        </div>
                      </v-list>
                      <v-list
                        class="px-3 pt-1"
                        color="transparent"
                        v-if="Permission.Delete"
                      >
                        <v-btn
                          depressed
                          color="transparent"
                          block
                          class="d-flex justify-start"
                          @click="dialog = true"
                        >
                          <v-icon color="#646464">mdi-delete</v-icon>
                          <span class="ml-4 text_style">Delete</span>
                        </v-btn>
                      </v-list>
                    </v-card>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card> -->
          </v-tab-item>

          <v-tab-item>
            <Membershiptab />
          </v-tab-item>
          <!------------- start Memebership information   -------------->
          <v-tab-item>
            <Purchasestab />
          </v-tab-item>
          <!------------- start CEU Hours for   -------------->
          <v-tab-item v-if="GetPreviewUser?.ExamsCredentials.includes(1)">
            <v-card flat>
              <div class="mt-10 d-flex justify-space-between heading-2">
                CEU Hours for {{ GetPreviewUser?.FirstName }}
                {{ GetPreviewUser?.LastName }}
              </div>
              <div class="mt-4">
                <span class="style_txt_hh2"
                  >For period beginning {{ convertStartDate }} to
                  {{ convertDate(endDate) }}
                </span>
              </div>
              <div class="mt-8 mb-3">Please Note:</div>
              <div>
                All Practicing CBPs, to maintain certification, are required to
                complete 32 hours of IBA-approved Continuing Education in the
                BodyTalk System or Life Sciences within the two-year period
                specified above.
              </div>
              <div class="my-3">
                <v-row class="mt-6">
                  <v-col cols="12" md="4" sm="6">
                    <v-card flat>
                      <v-text-field
                        dense
                        outlined
                        prepend-inner-icon="mdi-magnify"
                        label="Search"
                        single-line
                        v-model="CEUsearch"
                        @input="fetchCeusData"
                      >
                      </v-text-field>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="8" sm="6">
                    <div class="d-flex justify-end">
                      <v-btn
                        color="primary"
                        depressed
                        @click="AddCEUsDialog = true"
                        style="text-transform: none"
                        >Add CEUs</v-btn
                      >
                      <!------------Add CEUs --------------------------->
                      <v-dialog
                        persistent
                        v-model="AddCEUsDialog"
                        max-width="650"
                      >
                        <v-card class="px-6 py-4" v-if="AddCEUsDialog">
                          <div
                            class="d-flex justify-space-between align-center"
                          >
                            <div class="heading-2">Add CEUs</div>
                            <v-icon @click="closeAddCEU()">mdi-close</v-icon>
                          </div>
                          <div class="mt-5 mb-3">
                            If a User requires CEUs be added to their account
                            for extenuating circumstances, add them here. Note,
                            if a User needs a course added, add it on their
                            "Courses Taken" tab.
                          </div>
                          <div>
                            <div class="mb-3">
                              <b style="font-size: 18px">From Date</b>
                            </div>
                            <v-card flat max-width="300">
                              <v-menu
                                ref="fromdate"
                                v-model="fromdate"
                                :close-on-content-click="false"
                                :return-value.sync="form.FromDate"
                                transition="scale-transition"
                                offset-y
                                attach
                                :nudge-top="20"
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="form.FromDate"
                                    label="From Date"
                                    append-icon="mdi-calendar-range-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    dense
                                    outlined
                                    single-line
                                    :error-messages="
                                      $v.form.FromDate.$error
                                        ? 'From date is required'
                                        : null
                                    "
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="form.FromDate"
                                  no-title
                                  scrollable
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="fromdate = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.fromdate.save(form.FromDate)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-card>
                          </div>
                          <div>
                            <div class="mb-3">
                              <b style="font-size: 18px">To Date</b>
                            </div>
                            <v-card flat max-width="300">
                              <v-menu
                                ref="todate"
                                v-model="todate"
                                :close-on-content-click="false"
                                :return-value.sync="form.ToDate"
                                transition="scale-transition"
                                offset-y
                                attach
                                :nudge-top="20"
                                min-width="auto"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="form.ToDate"
                                    label="To Date"
                                    append-icon="mdi-calendar-range-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    dense
                                    outlined
                                    single-line
                                    :error-messages="
                                      $v.form.ToDate.$error
                                        ? 'To date is required'
                                        : null
                                    "
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="form.ToDate"
                                  no-title
                                  scrollable
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="todate = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.todate.save(form.ToDate)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-card>
                          </div>
                          
                          <div>
                            <div class="my-3">
                              <b style="font-size: 18px"
                                >Instructor or Institute (leave blank if not
                                applicable)
                              </b>
                            </div>
                            <v-card flat max-width="300">
                              <v-text-field
                                dense
                                single-line
                                v-model="form.Institute"
                                outlined
                                :error-messages="
                                  $v.form.Institute.$error
                                    ? 'Institute is required'
                                    : null
                                "
                              ></v-text-field>
                            </v-card>
                          </div>
                          <div>
                            <div class="">
                              <b style="font-size: 18px">Courses </b>
                            </div>
                            <v-card flat max-width="300">
                              <v-text-field
                                dense
                                single-line
                                v-model="form.Course"
                                outlined
                                :error-messages="
                                  $v.form.Course.$error
                                    ? 'Course is required'
                                    : null
                                "
                              ></v-text-field>
                            </v-card>
                          </div>
                          <div>
                            <div class="my-4">
                              <b style="font-size: 18px">Hours </b>
                            </div>
                            <v-card flat max-width="300">
                              <!-- <v-select
                                attach
                                :items="AddCEUsHours"
                                dense
                                single-line
                                v-model="form.Hours"
                                outlined
                              ></v-select> -->
                              <v-text-field
                                dense
                                single-line
                                v-model="form.Hours"
                                outlined
                                :error-messages="
                                  $v.form.Hours.$error
                                    ? 'Hours is required'
                                    : null
                                "
                              ></v-text-field>
                            </v-card>
                          </div>
                          <div
                            class="heading-2 mt-5 mb-4"
                            style="font-size: 20px"
                          >
                            CEUs will appear on User CEU page as follows:
                          </div>
                          
                          <v-row>
                            <v-col cols="3">From Date:</v-col>
                            <v-col cols="9">{{ form.FromDate }}</v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3">To Date:</v-col>
                            <v-col cols="9">{{ form.ToDate }}</v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3">Course:</v-col>
                            <v-col cols="9">{{ form.Course }}</v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3">Institute:</v-col>
                            <v-col cols="9">{{ form.Institute }}</v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3">Hours:</v-col>
                            <v-col cols="9">{{ form.Hours }}</v-col>
                          </v-row>
                          <div class="my-8 d-flex justify-end gap-4">
                            <v-btn
                              color=""
                              class="px-14 py-4"
                              depressed
                              @click="closeAddCEU()"
                              >Cancel</v-btn
                            >
                            <v-btn
                              color="primary"
                              class="px-14 py-4"
                              depressed
                              :disabled="btnloader"
                              @click="SubmitAddCEUs"
                            >
                              <span v-if="btnloader != true">Submit</span>
                              <v-progress-circular
                                indeterminate
                                size="20"
                                class="px-5"
                                color="white"
                                v-show="btnloader"
                              ></v-progress-circular
                            ></v-btn>
                          </div>
                        </v-card>
                      </v-dialog>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <!------------------section three ( data table )------------------------>

              <div>
                <!-- :search="CEUsearch" -->
                <v-card class="mt-6" outlined>
                  <v-data-table
                    :headers="CEUheaders"
                    :items="getUserCEUs?.result"
                    :loading="btnloader"
                    loading-text="Loading... Please wait"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:[`item.ToDate`]="{ item }">
                      <span class="index_span_2_style">
                        {{ item.ToDate?.split("T")[0] }}
                      </span>
                    </template>
                    <template v-slot:[`item.FromDate`]="{ item }">
                      <span class="index_span_2_style">
                        {{ item.FromDate?.split("T")[0] }}
                      </span>
                    </template>

                    <!-- <template v-slot:[`item.actions`]="{ item }">
                      <v-menu
                        transition="scroll-y-transition"
                        offset-y
                        color="transparent"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                            mdi-dots-horizontal
                          </v-icon>
                        </template>
                        <v-card flat>
                          <v-list class="px-3 pt-1" color="transparent">
                            <div class="d-flex">
                              <v-btn
                                depressed
                                color="transparent"
                                block
                                @click="editCeusDialogOpen(item)"
                                class="d-flex justify-start"
                              >
                                <v-icon color="#646464">mdi-pencil</v-icon>
                                <span class="ml-4 text_style">Edit</span>
                              </v-btn>
                            </div>
                          </v-list>
                          <v-list class="px-3 pt-1" color="transparent">
                            <div class="d-flex">
                              <v-btn
                                depressed
                                color="transparent"
                                block
                                class="d-flex justify-start"
                                @click="deleteCeus(item)"
                              >
                                <v-icon color="#646464">mdi-delete</v-icon>
                                <span class="ml-4 text_style">Delete </span>
                              </v-btn>
                            </div>
                          </v-list>
                          <v-list
                            class="px-3 pt-1"
                            color="transparent"
                            v-if="Permission.Delete"
                          >
                            <v-btn
                              depressed
                              color="transparent"
                              block
                              class="d-flex justify-start"
                              @click="dialog = true"
                            >
                              <v-icon color="#646464">mdi-delete</v-icon>
                              <span class="ml-4 text_style">Delete</span>
                            </v-btn>
                          </v-list>
                        </v-card>
                      </v-menu>
                    </template> -->
                  </v-data-table>
                </v-card>
              </div>
              <div class="mt-10">
                <v-row>
                  <v-col cols="0" md="8"></v-col>
                  <v-col cols="0" md="4" class="d-flex justify-center"
                    ><b style="margin-left: 37%">
                      Total : {{ getUserCEUs?.CEUsSum }}
                    </b></v-col
                  >
                </v-row>
              </div>
              <v-divider class="divider"></v-divider>
              <!-- <div class="mt-3">
                <v-row>
                  <v-col cols="0" md="4" class="d-flex justify-start"
                    ><b>
                      CEUs rolled in from last year :
                      {{ getUserCEUs.CEUsInLastFiveYears }}
                    </b></v-col
                  >
                  <v-col cols="0" md="4" class="d-flex justify-center"
                    ><b> CEUs required for 2 years : 5 </b></v-col
                  >
                  <v-col cols="0" md="4" class="d-flex justify-center"
                    ><b> CEUs eligible to be carried over : 32 </b></v-col
                  >
                </v-row>
              </div>
              <v-divider class="divider"></v-divider> -->
              <div class="d-flex justify-space-between mb-14 mt-9">
                <v-btn
                  color="#afadad"
                  class="px-8 py-5"
                  depressed
                  outlined
                  @click="previousPeriod()"
                >
                  <div class="text_style black--text">
                    Previous period
                  </div></v-btn
                >
                <v-btn color="primary px-8 py-5" depressed @click="nextPeriod()"
                  ><div class="text_style">Next period</div></v-btn
                >
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <Coursestab />
          </v-tab-item>
          <!------------- End Memebership information  -------------->

          <v-tab-item>
            <examandcredentials />
          </v-tab-item>
          <v-tab-item>
            <div>
              <coursestabcomponent />
            </div>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" md="6">
                <div class="mt-10 d-flex justify-space-between heading-2">
                  <span>Notes</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-card flat class="d-flex justify-end mt-2">
                  <div class="d-flex justify-end mt-10">
                    <v-btn
                      rounded
                      outlined
                      color="#1884CD"
                      class=""
                      dark
                      @click="AddNotesDialogOpen()"
                      style="
                        text-transform: none !important;
                        border: 1px solid #d2e5fc;
                      "
                      >Add Note
                    </v-btn>

                    <v-dialog
                      v-model="AddNotesDialog"
                      max-width="500"
                      persistent
                    >
                      <v-card class="pa-9">
                        <div class="d-flex align-center justify-space-between">
                          <h4 class="mb-5">
                            {{ this.edit ? "Edit Note" : "Add Note" }}
                          </h4>
                          <div>
                            <v-icon
                              @click="
                                AddNotesDialog = false;
                                this.edit = false;
                              "
                              >mdi-close</v-icon
                            >
                          </div>
                        </div>
                        <div>
                          <v-text-field
                            label="Subject"
                            v-model="note.Subject"
                            :error-messages="
                              $v.note.Subject.$error
                                ? 'Subject is required'
                                : null
                            "
                          ></v-text-field>
                          <v-textarea
                            label="Text"
                            v-model="note.Text"
                            :error-messages="
                              $v.note.Text.$error
                                ? 'Text is required'
                                : null
                            "
                          ></v-textarea>
                        </div>
                        <div class="d-flex justify-end">
                          <v-btn
                            color="primary"
                            text
                            @click="
                              AddNotesDialog = false;
                              this.edit = false;
                            "
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="primary"
                            class="ml-5"
                            text
                            @click="AddNewNotes"
                            >Save</v-btn
                          >
                        </div>
                      </v-card>
                    </v-dialog>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <div>
              <v-card class="mt-6" outlined>
                <v-data-table
                  :headers="notesheaders"
                  :items="GetAllUserNotesByUserId"
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:[`item.index`]="{ index }">
                    <span class="index_span_2_style">
                      {{ index + 1 }}
                    </span>
                  </template>
                  <!-- <template v-slot:[`item.notes`]="{ item }">
                    <span class="index_span_2_style">
                      {{ item.notes }}
                    </span>
                  </template> -->
                  <template v-slot:[`item.CreatedDate`]="{ item }">
                    <span class="index_span_2_style">
                      {{ item?.CreatedDate?.split("T")[0].replaceAll("-", "/") }}
                    </span>
                  </template>
                  <template v-slot:[`item.CreatedByName`]="{ item }">
                    <span class="index_span_2_style">
                      {{ item.CreatedByName?.Name || "Admin" }}
                    </span>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-menu
                      transition="scroll-y-transition"
                      offset-y
                      color="transparent"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                          mdi-dots-horizontal
                        </v-icon>
                      </template>
                      <v-card flat>
                        <v-list class="px-3 pt-1" color="transparent">
                          <div class="d-flex">
                            <v-btn
                              depressed
                              color="transparent"
                              @click="ViewNotesDialogOpen(item)"
                              block
                              class="d-flex justify-start"
                            >
                              <v-icon color="#646464">mdi-eye</v-icon>
                              <span class="ml-4 text_style">View </span>
                            </v-btn>
                          </div>
                        </v-list>
                        <v-list class="px-3 pt-1" color="transparent">
                          <div class="d-flex">
                            <v-btn
                              depressed
                              color="transparent"
                              block
                              @click="editDialogOpen(item)"
                              class="d-flex justify-start"
                            >
                              <v-icon color="#646464">mdi-pencil</v-icon>
                              <span class="ml-4 text_style">Edit</span>
                            </v-btn>
                          </div>
                        </v-list>
                        <v-list class="px-3 pt-1" color="transparent">
                          <div class="d-flex">
                            <v-btn
                              depressed
                              color="transparent"
                              block
                              class="d-flex justify-start"
                              @click="deleteItem(item)"
                            >
                              <v-icon color="#646464">mdi-delete</v-icon>
                              <span class="ml-4 text_style">Delete </span>
                            </v-btn>
                          </div>
                        </v-list>
                        <v-list
                          class="px-3 pt-1"
                          color="transparent"
                          v-if="Permission.Delete"
                        >
                          <v-btn
                            depressed
                            color="transparent"
                            block
                            class="d-flex justify-start"
                            @click="dialog = true"
                          >
                            <v-icon color="#646464">mdi-delete</v-icon>
                            <span class="ml-4 text_style">Delete</span>
                          </v-btn>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </template>
                </v-data-table>
              </v-card>
            </div>
          </v-tab-item>
        </v-tabs-items>
        <!------------- End Tabs --------------->
      </div>
    </v-card>

    <!-- user bio -->
    <v-dialog v-model="viewBioDialog" max-width="900">
      <v-card>
        <div>
          <BioComponent />
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addreseditdialog" persistent max-width="400">
      <v-card>
        <div>
          <edit-user-address
            :addreseditdialog="addreseditdialog"
            @close="close"
          />
        </div>
      </v-card>
    </v-dialog>
    <!------------- forget password----------------------->
    <v-dialog persistent max-width="600" v-model="forgetPasswordDialog">
      <v-card class="pa-8">
        <div class="d-flex justify-space-between align-center">
          <div class="h2">Edit password</div>
          <v-icon @click="closeResetPasswordDialog()">mdi-close</v-icon>
        </div>
        <div class="mt-8">
         <!-- <v-text-field
            v-model="updatePassword.OldPassword"
            outlined
            dense
            autocomplete="off"
            placeholder="Enter Old Password"
            :error-messages="
              getErrorMessageforPassword('OldPassword', 'OldPassword')
            "
          ></v-text-field> -->
          <!-- :append-icon="showPassowrd3 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassowrd3 ? 'text' : 'password'"
            @click:append="showPassowrd3 = !showPassowrd3" -->
          <v-text-field
            v-model="$v.updatePassword.NewPassword.$model"
            outlined
            dense
            class="mt-4 mb-2"
            placeholder="Enter New Password"
            :error-messages="
              getErrorMessageforPassword('NewPassword', 'NewPassword')
            "
          ></v-text-field>
          <!-- :append-icon="showPassowrd1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassowrd1 ? 'text' : 'password'"
            @click:append="showPassowrd1 = !showPassowrd1" -->
          <v-text-field
            v-model="updatePassword.ConfirmNewPassword"
            outlined
            dense
            class="mt-4 mb-2"
            placeholder="Confirm New Password"
            :error-messages="
              getErrorMessageforPassword(
                'ConfirmNewPassword',
                'ConfirmNewPassword'
              )
            "
          ></v-text-field>
          <!-- :append-icon="showPassowrd2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassowrd2 ? 'text' : 'password'"
            @click:append="showPassowrd2 = !showPassowrd2" -->
        </div>
        <div class="my-5 d-flex justify-end">
          <router-link to="/forgetpassword" class="link">
            <span class="primary--text">Forget Password</span>
          </router-link>
        </div>
        <div class="d-flex justify-end">
          <v-btn class="px-7" depressed @click="closeResetPasswordDialog()"
            >Cancel</v-btn
          >
          <v-btn
            class="px-7 ml-4"
            depressed
            color="primary"
            @click="ResetPassowrd()"
          >
            <v-progress-circular
              v-if="BtnLoader"
              indeterminate
              size="22"
              color="white"
              class="px-7"
            ></v-progress-circular>
            <span v-else>Confirm</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!---------------------------Edit Address Dialog----------------------------->
    <v-dialog v-model="EditAddressDialog" width="600" persistent>
      <v-card class="pa-6">
        <div class="px-4 py-4 d-flex justify-space-between align-center">
          <span class="h3">Edit address</span>
          <v-icon @click="closeDialog()">mdi-close</v-icon>
        </div>
        <div style="border-left:3px solid #c0c0c0" class="ml-4 pl-2 pr-4">
          <div><em>Options in each dropdown depend on the selection above. Fields can be left blank but will affect public location filters. "Address" can include your preferred text. Some rural or unique locations may not appear—if you don’t see what you need, email <a href="mailto:office@bodytalksystem.com">office@bodytalksystem.com</a> and we’ll add it.</em></div>
        </div>
        <div class="mx-5">
          <div class="mt-4">
            <div class="">
              <b>Street Address</b>
            </div>
            <v-text-field
              dense
              outlined
              flat
              single-line
              append-icon="mdi-check"
              class="py-4"
              v-model="Addresses.StreetAddress1"
              :error-messages="
                $v.Addresses.StreetAddress1.$error
                  ? 'Street address is required'
                  : null
              "
            ></v-text-field>
            <!-- <div class="">
              <b>Street Address2</b>
            </div>
            <v-text-field
              dense
              outlined
              single-line
              class="my-5"
              placeholder="Enter Address"
              v-model="Addresses.StreetAddress2"
            ></v-text-field> -->
            <v-row>
              <v-col col="12" md="12" class="py-1">
                <div class="pb-3">
                  <b class="pb-2">Region</b>
                </div>
                <v-autocomplete
                  dense
                  outlined
                  :items="regions"
                  v-model="Addresses.region"
                  attach
                  @change="fetchCountries"
                />
                
              </v-col>
              <v-col col="12" md="12" class="py-1">
                <div class="pb-3">
                  <b class="pb-2">Country</b>
                </div>
                <v-autocomplete
                  dense
                  outlined
                  attach
                  :items="countries"
                  v-model="Addresses.country"
                  @change="fetchStates"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" md="12" class="py-1">
                <div class="pb-3">
                  <b class="pb-2">State / Province</b>
                </div>
                <v-autocomplete
                  dense
                  outlined
                  attach
                  :items="states"
                  v-model="Addresses.state"
                  @change="fetchCities"
                />
               
              </v-col>
              <v-col col="12" md="12" class="py-1">
                <div class="pb-3">
                  <b>City</b>
                  <div>
                    <div class="text-muted font-italic" style="font-size:14px;">
                      If your city is not listed, select "Other" and enter your city, municipality, or community name.
                    </div>
                  </div>
                </div>
                <v-autocomplete
                  dense
                  outlined
                  attach
                  :items="['Other',...cities]"
                  v-model="Addresses.city"
                />
                <v-text-field
                  v-if="Addresses.city === 'Other'"
                  v-model="otherCity"
                  label="Enter your community or muncipality"
                  dense
                  outlined
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" md="12" class="py-1">
                <div class="pb-3">
                  <b class="pb-2">Zip Code</b>
                </div>
                <v-text-field
                  dense
                  outlined
                  placeholder=""
                  single-line
                  v-model="Addresses.zipcode"
                  ></v-text-field>
              </v-col>
            </v-row>
            <div class="pt-3">
              <p class="">Should the address be visible publicly, YES or NO</p>
            </div>
            <div class="mx-3">
              <b-form-radio
                v-model="Addresses.IsPublicallyVisible"
                :value="true"
                class="mb-2"
                ><span class="pl-3">Yes</span></b-form-radio
              >
              <b-form-radio
                v-model="Addresses.IsPublicallyVisible"
                :value="false"
                ><span class="pl-3">No</span></b-form-radio
              >
            </div>
            <div
              class="red--text" style="font-size:12px"
              v-if="$v.Addresses.IsPublicallyVisible.$error"
            >
              Must be select one option
            </div>
          </div>
          <div class="mt-6">
            <p class="">Is this address a clinic address or home address?</p>
            <div class="mx-3">
              <b-form-checkbox
                class="mb-2"
                v-model="Addresses.IsClinicAddress"
                :value="true"
              >
                <span class="pl-3"> Clinic </span> </b-form-checkbox
              ><b-form-checkbox v-model="Addresses.IsHomeAddress" :value="true">
                <span class="pl-3"> Home</span>
              </b-form-checkbox>
            </div>
          </div>
          <div class="mt-6">
            <p class="">Is this your shipping address?</p>
            <div class="mx-3">
              <b-form-radio
                v-model="Addresses.IsShippingAddress"
                :value="true"
                class="mb-2"
                ><span class="pl-3">Yes</span></b-form-radio
              >
              <b-form-radio v-model="Addresses.IsShippingAddress" :value="false"
                ><span class="pl-3">No</span></b-form-radio
              >
            </div>
            <div class="red--text" style="font-size:12px" v-if="$v.Addresses.IsShippingAddress.$error">
              Must be select one option
            </div>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-10 py-6"
            color="#A1A3A8"
            text
            @click="closeDialog()"
            style="text-transform: none"
          >
            Cancel
          </v-btn>

          <v-btn
            depressed
            color="primary"
            class="px-14 py-6"
            style="text-transform: none"
            :disabled="btnloader"
            @click="updateAddress()"
          >
            <span v-if="btnloader != true"> Save </span>
            <v-progress-circular
              indeterminate
              size="20"
              v-else
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="DeleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="DeleteDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="btnloader" @click="DeleteAddress()">
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              size="20"
              v-else
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!---------------------------Edit Notes Dialog----------------------------->
    <v-dialog v-model="EditNotesDialog" max-width="500" persistent>
      <v-card class="pa-9">
        <div class="d-flex align-center justify-space-between">
          <h4 class="mb-5">Edit Note</h4>
          <div>
            <v-icon @click="EditNotesDialog = false">mdi-close</v-icon>
          </div>
        </div>
        <div>
          <v-text-field
            label="Subject"
            v-model="note.Subject"
            :error-messages="
              $v.note.Subject.$error ? 'Subject is required' : null
            "
          ></v-text-field>
          <v-textarea
            label="Text"
            v-model="note.Text"
            :error-messages="
              $v.note.Text.$error ? 'Text is required' : null
            "
          ></v-textarea>
        </div>
        <div class="d-flex justify-end">
          <v-btn color="primary" text @click="EditNotesDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" class="ml-5" text @click="AddNewNotes"
            >Save</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <!---------------------------View Notes Dialog----------------------------->
    <v-dialog v-model="ViewNotesDialog" max-width="500" persistent>
      <v-card class="pa-9">
        <div class="d-flex align-center justify-space-between">
          <h4 class="mb-5">View Note</h4>
          <div>
            <v-icon @click="ViewNotesDialog = false">mdi-close</v-icon>
          </div>
        </div> 
        <div>
          <v-text-field
            label="Subject"
            readonly
            v-model="viewNote.Subject"
          ></v-text-field>
          <v-textarea
            label="Text"
            readonly
            v-model="viewNote.Text"
          ></v-textarea>
        </div>
        <!-- <div class="d-flex justify-end">
          <v-btn color="primary" text @click="ViewNotesDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="primary" class="ml-5" text @click="AddNewNotes"
            >Save</v-btn
          >
        </div> -->
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import userimageuploaderComponent from "./ImageUploader.component.vue";
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import EditUserAddress from "./edit-user-address.vue";
import Coursestabcomponent from "./tabscomponents/coursestabcomponent.vue";
import Membershiptab from "./tabscomponents/membershiptab.vue";
import Purchasestab from "./tabscomponents/purchasestab.vue";
import Coursestab from "./tabscomponents/coursestab.vue";
import Examandcredentials from "./tabscomponents/examandcredentials.vue";
import BioComponent from "./BioComponent.vue";
// import axios from "axios";
import {
  required,
  sameAs,
  // not,
  email,
  // numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
// const alphaWithSpaces = (value) => {
//   if (!value) return true;
//   return /^[\p{L}\s’.-]+$/u.test(value);
// };
const alphaWithSpacesAndSpecialChars = (value) => {
  if (!value) return true;
  return /^[A-Za-z\s!@#$%^&*()_+\-=[\]{};'’:"\\|,.<>/?áàãâäåāăąçćĉċčðďèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĵķĺļľłńņňŋòóôõöøōŏőœñŕŗřśŝşšţťŧùúûüũūŭůűųŵýÿŷźżžÁÀÃÂÄÅĀĂĄÇĆĈĊČÐĎÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĴĶĹĻĽŁŃŅŇŊÒÓÔÕÖØŌŎŐŒŔŖŘŚŜŞŠŢŤŦÙÚÛÜŨŪŬŮŰŲŴÝŸŶŹŻŽ\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]+$/.test(value);
  // to allow spaces, special char, latin char. Japanese characters (Kanji, Hiragana and Katakana scripts)
};
// allow numbers, spaces, dashes, parentheses, and plus signs
const phoneWithSpecialChars = (value) => {
  if (!value) return true;
  return /^[0-9+\-\s()]+$/.test(value);
};

export default {
  mixins: [validationMixin],
  components: {
    EditUserAddress,
    Coursestabcomponent,
    Membershiptab,
    Purchasestab,
    Coursestab,
    Examandcredentials,
    userimageuploaderComponent,
    BioComponent,
  },
  computed: {
    ...mapGetters([
      "GetPreviewUser",
      "getUserCEUs",
      "GetAllAddresses",
      "GetTimeZone",
      "GetCourses",
      "GetLoggedInUser",
      "getMembershipByUserId",
      "GetAllUserNotesByUserId",
    ]),
    previousMembershipName() {
      const membershipMap = {
        1: "Starter",
        2: "Access",
        3: "Standard",
        4: "Practitioner",
        5: "Instructor",
        6: "LifeSciences",
        7: "Deceased",
        8: "InActive",
        9: "Trainee Instructor",
        10: "Senior Instructor",
      };
      return membershipMap[this.getMembershipByUserId?.PreviousMembershipID] || 'Unknown';
    },
    convertStartDate() {
      return this.convertDate(this.startDate);
    },
  },
  async mounted() {
    this.isValue = localStorage.getItem("AccountType");
    if (!this.GetPreviewUser) {
      await this.$store.dispatch("GetPreviewUser", this.$route.params.id);
    }
    this.startDate = this.calculateDates(this.GetPreviewUser?.CBPExamDate);
    this.endDate = this.addAndSubYearsToDate(this.startDate, 2, "add");
    if (this.GetPreviewUser && this.GetPreviewUser.WebpageURL == "null") {
      this.GetPreviewUser.WebpageURL = "";
    }
    await this.$store.dispatch("AllAddress", this.GetPreviewUser.Id);
    await this.fetchData();
    // await this.fetchCourses()
    await this.fetchCeusData();

    if (this.GetPreviewUser == null) {
      this.$router.push("/users");
    }
    this.specializationsArray =
      this.GetPreviewUser.Specializations != null
        ? this.GetPreviewUser.Specializations.split(",")
        : [];
  },

  name: "seeprofilecomponent",
  data() {
    return {
      isValue: "",
      startDate: "",
      endDate: "",
      viewBioDialog: false,
      customMessage: "No data available",
      AllTimeZone: moment.tz.names().map((tz) => ({
        name: `(UTC${moment.tz(tz).format('Z')}) ${tz.replace('_', ' ')}`,
        timezone: tz,
      })),
      ShippingTypeArray: [],
      fromdate: false,
      regions: [
        'Africa',
        // 'Americas',
        'Asia',
        'Caribbean',
        'Europe',
        'North America',
        'Oceania',
        'South America',
      ],
      countries: [],
      states: [],
      cities: [],
      otherCity: "",
      todate: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      todate1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      note: {
        Id: 0,
        Subject: "",
        Text: "",
        CreatedBy: "",
        UserId: "",
      },
      viewNote: {
        Subject: "",
        Text: "",
      },
      AddNotesDialog: false,
      EditNotesDialog: false,
      ViewNotesDialog: false,
      
      AddCEUs: {
        Date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        type: "",
        hours: "",
      },
        countryList: [
          "United States",
          "Afghanistan",
          "Albania",
          "Algeria",
          "American Samoa",
          "Andorra",
          "Angola",
          "Anguilla",
          "Antarctica",
          "Antigua and Barbuda",
          "Argentina",
          "Armenia",
          "Aruba",
          "Australia",
          "Austria",
          "Azerbaijan",
          "Bahamas (the)",
          "Bahrain",
          "Bangladesh",
          "Barbados",
          "Belarus",
          "Belgium",
          "Belize",
          "Benin",
          "Bermuda",
          "Bhutan",
          "Bolivia (Plurinational State of)",
          "Bonaire, Sint Eustatius and Saba",
          "Bosnia and Herzegovina",
          "Botswana",
          "Bouvet Island",
          "Brazil",
          "British Indian Ocean Territory (the)",
          "Brunei Darussalam",
          "Bulgaria",
          "Burkina Faso",
          "Burundi",
          "Cabo Verde",
          "Cambodia",
          "Cameroon",
          "Canada",
          "Cayman Islands (the)",
          "Central African Republic (the)",
          "Chad",
          "Chile",
          "China",
          "Christmas Island",
          "Cocos (Keeling) Islands (the)",
          "Colombia",
          "Comoros (the)",
          "Congo (the Democratic Republic of the)",
          "Congo (the)",
          "Cook Islands (the)",
          "Costa Rica",
          "Croatia",
          "Cuba",
          "Curaçao",
          "Cyprus",
          "Czechia",
          "Côte d'Ivoire",
          "Denmark",
          "Djibouti",
          "Dominica",
          "Dominican Republic (the)",
          "Ecuador",
          "Egypt",
          "El Salvador",
          "Equatorial Guinea",
          "Eritrea",
          "Estonia",
          "Eswatini",
          "Ethiopia",
          "Falkland Islands (the) [Malvinas]",
          "Faroe Islands (the)",
          "Fiji",
          "Finland",
          "France",
          "French Guiana",
          "French Polynesia",
          "French Southern Territories (the)",
          "Gabon",
          "Gambia (the)",
          "Georgia",
          "Germany",
          "Ghana",
          "Gibraltar",
          "Greece",
          "Greenland",
          "Grenada",
          "Guadeloupe",
          "Guam",
          "Guatemala",
          "Guernsey",
          "Guinea",
          "Guinea-Bissau",
          "Guyana",
          "Haiti",
          "Heard Island and McDonald Islands",
          "Holy See (the)",
          "Honduras",
          "Hong Kong",
          "Hungary",
          "Iceland",
          "India",
          "Indonesia",
          "Iran (Islamic Republic of)",
          "Iraq",
          "Ireland",
          "Isle of Man",
          "Israel",
          "Italy",
          "Jamaica",
          "Japan",
          "Jersey",
          "Jordan",
          "Kazakhstan",
          "Kenya",
          "Kiribati",
          "Korea (the Democratic People's Republic of)",
          "Korea (the Republic of)",
          "Kuwait",
          "Kyrgyzstan",
          "Lao People's Democratic Republic (the)",
          "Latvia",
          "Lebanon",
          "Lesotho",
          "Liberia",
          "Libya",
          "Liechtenstein",
          "Lithuania",
          "Luxembourg",
          "Macao",
          "Madagascar",
          "Malawi",
          "Malaysia",
          "Maldives",
          "Mali",
          "Malta",
          "Marshall Islands (the)",
          "Martinique",
          "Mauritania",
          "Mauritius",
          "Mayotte",
          "Mexico",
          "Micronesia (Federated States of)",
          "Moldova (the Republic of)",
          "Monaco",
          "Mongolia",
          "Montenegro",
          "Montserrat",
          "Morocco",
          "Mozambique",
          "Myanmar",
          "Namibia",
          "Nauru",
          "Nepal",
          "Netherlands",
          "New Caledonia",
          "New Zealand",
          "Nicaragua",
          "Niger (the)",
          "Nigeria",
          "Niue",
          "Norfolk Island",
          "Northern Mariana Islands (the)",
          "Norway",
          "Oman",
          "Pakistan",
          "Palau",
          "Palestine, State of",
          "Panama",
          "Papua New Guinea",
          "Paraguay",
          "Peru",
          "Philippines",
          "Pitcairn",
          "Poland",
          "Portugal",
          "Puerto Rico",
          "Qatar",
          "Republic of North Macedonia",
          "Romania",
          "Russian Federation (the)",
          "Rwanda",
          "Réunion",
          "Saint Barthélemy",
          "Saint Helena, Ascension and Tristan da Cunha",
          "Saint Kitts and Nevis",
          "Saint Lucia",
          "Saint Martin (French part)",
          "Saint Pierre and Miquelon",
          "Saint Vincent and the Grenadines",
          "Samoa",
          "San Marino",
          "Sao Tome and Principe",
          "Saudi Arabia",
          "Senegal",
          "Serbia",
          "Seychelles",
          "Sierra Leone",
          "Singapore",
          "Sint Maarten (Dutch part)",
          "Slovakia",
          "Slovenia",
          "Solomon Islands",
          "Somalia",
          "South Africa",
          "South Georgia and the South Sandwich Islands",
          "South Sudan",
          "Spain",
          "Sri Lanka",
          "Sudan (the)",
          "Suriname",
          "Svalbard and Jan Mayen",
          "Sweden",
          "Switzerland",
          "Syrian Arab Republic",
          "Taiwan",
          "Tajikistan",
          "Tanzania, United Republic of",
          "Thailand",
          "Timor-Leste",
          "Togo",
          "Tokelau",
          "Tonga",
          "Trinidad and Tobago",
          "Tunisia",
          "Turkey",
          "Turkmenistan",
          "Turks and Caicos Islands (the)",
          "Tuvalu",
          "Uganda",
          "Ukraine",
          "United Arab Emirates (the)",
          "United Kingdom",
          "Uruguay",
          "USA Minor Outlying Islands",
          "Uzbekistan",
          "Vanuatu",
          "Venezuela (Bolivarian Republic of)",
          "Viet Nam",
          "Virgin Islands (British)",
          "Virgin Islands (U.S.)",
          "Wallis and Futuna",
          "Western Sahara",
          "Yemen",
          "Zambia",
          "Zimbabwe",
          "Åland Islands",
        ],

      AddCEUsHours: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
      ],
      form: {
        FromDate: "",
        ToDate: "",
        Institute: "",
        Hours: null,
        Course: null,
        UserId: 0,
        CreatedBy: 0,
      },
      DeleteDialog: false,
      deleteAddressID: null,
      EditAddressDialog: false,
      showPassowrd1: false,
      showPassowrd2: false,
      // showPassowrd3: false,
      BtnLoader: false,
      forgetPasswordDialog: false,
      updatePassword: {
       //  OldPassword: "",
        NewPassword: "",
        ConfirmNewPassword: "",
        Email: "",
      },
      NewOrEditText: "Add new",
      Addresses: {
        IsPublicallyVisible: null,
        IsClinicAddress: false,
        IsHomeAddress: false,
        IsShippingAddress: null,
        StreetAddress1: "",
        StreetAddress2: "",
        region:null,
        city: "",
        state: "",
        zipcode: "",
        country: "",
        UserId: null,
        Id: null,
      },
      regionMapping: {
        // Africa
        Algeria: "Africa",
        Angola: "Africa",
        Benin: "Africa",
        Botswana: "Africa",
        "Burkina Faso": "Africa",
        Burundi: "Africa",
        "Cabo Verde": "Africa",
        Cameroon: "Africa",
        "Central African Republic": "Africa",
        Chad: "Africa",
        Comoros: "Africa",
        "Congo (Congo-Brazzaville)": "Africa",
        "Congo (Kinshasa)": "Africa",
        Djibouti: "Africa",
        Egypt: "Africa",
        "Equatorial Guinea": "Africa",
        Eritrea: "Africa",
        "Eswatini": "Africa",
        "Eswatini (fmr. 'Swaziland')": "Africa",
        Ethiopia: "Africa",
        Gabon: "Africa",
        Gambia: "Africa",
        Ghana: "Africa",
        Guinea: "Africa",
        "Guinea-Bissau": "Africa",
        "Ivory Coast": "Africa",
        Kenya: "Africa",
        Lesotho: "Africa",
        Liberia: "Africa",
        Libya: "Africa",
        Madagascar: "Africa",
        Malawi: "Africa",
        Mali: "Africa",
        Mauritania: "Africa",
        Mauritius: "Africa",
        Morocco: "Africa",
        Mozambique: "Africa",
        Namibia: "Africa",
        Niger: "Africa",
        Nigeria: "Africa",
        Rwanda: "Africa",
        "Sao Tome and Principe": "Africa",
        Senegal: "Africa",
        Seychelles: "Africa",
        "Sierra Leone": "Africa",
        Somalia: "Africa",
        "South Africa": "Africa",
        "South Sudan": "Africa",
        Sudan: "Africa",
        Tanzania: "Africa",
        Togo: "Africa",
        Tunisia: "Africa",
        Uganda: "Africa",
        "United Republic of Tanzania": "Africa",
        Zambia: "Africa",
        Zimbabwe: "Africa",
        // Asia
        Afghanistan: "Asia",
        Armenia: "Asia",
        Azerbaijan: "Asia",
        Bahrain: "Asia",
        Bangladesh: "Asia",
        Bhutan: "Asia",
        Brunei: "Asia",
        Cambodia: "Asia",
        China: "Asia",
        Cyprus: "Asia",
        Georgia: "Asia",
        India: "Asia",
        Indonesia: "Asia",
        Iran: "Asia",
        Iraq: "Asia",
        Israel: "Asia",
        Japan: "Asia",
        Jordan: "Asia",
        Kazakhstan: "Asia",
        Kuwait: "Asia",
        Kyrgyzstan: "Asia",
        Laos: "Asia",
        Lebanon: "Asia",
        Malaysia: "Asia",
        Maldives: "Asia",
        Mongolia: "Asia",
        "Myanmar": "Asia",
        "Myanmar (Burma)": "Asia",
        Nepal: "Asia",
        "North Korea": "Asia",
        Oman: "Asia",
        Pakistan: "Asia",
        "Palestine": "Asia",
        "Palestine State": "Asia",
        Philippines: "Asia",
        Qatar: "Asia",
        "Hong Kong": "Asia",
        "Saudi Arabia": "Asia",
        Singapore: "Asia",
        "South Korea": "Asia",
        "Sri Lanka": "Asia",
        Syria: "Asia",
        Tajikistan: "Asia",
        Thailand: "Asia",
        "Timor-Leste": "Asia",
        Turkey: "Asia",
        Turkmenistan: "Asia",
        "United Arab Emirates": "Asia",
        Uzbekistan: "Asia",
        Vietnam: "Asia",
        Yemen: "Asia",
         // North America
        "Antigua and Barbuda": "North America",
        Bahamas: "North America",
        Barbados: "North America",
        Belize: "North America",
        Canada: "North America",
        "Costa Rica": "North America",
        Cuba: "North America",
        Dominica: "North America",
        "Dominican Republic": "North America",
        "El Salvador": "North America",
        Grenada: "North America",
        Guatemala: "North America",
        Haiti: "North America",
        Honduras: "North America",
        Jamaica: "North America",
        Mexico: "North America",
        Nicaragua: "North America",
        Panama: "North America",
        "Saint Kitts and Nevis": "North America",
        "Saint Lucia": "North America",
        "Saint Vincent and the Grenadines": "North America",
        "Trinidad and Tobago": "North America",
        "United States": "North America",
        // Caribbean
        
        // Central America
        
        // Europe
        Albania: "Europe",
        Andorra: "Europe",
        Austria: "Europe",
        Belarus: "Europe",
        Belgium: "Europe",
        "Bosnia and Herzegovina": "Europe",
        Bulgaria: "Europe",
        Croatia: "Europe",
        "Czechia": "Europe",
        "Czech Republic": "Europe",
        Denmark: "Europe",
        Estonia: "Europe",
        Finland: "Europe",
        France: "Europe",
        Germany: "Europe",
        Greece: "Europe",
        Hungary: "Europe",
        Iceland: "Europe",
        Ireland: "Europe",
        Italy: "Europe",
        Kosovo: "Europe",
        Latvia: "Europe",
        Liechtenstein: "Europe",
        Lithuania: "Europe",
        Luxembourg: "Europe",
        Malta: "Europe",
        Moldova: "Europe",
        Monaco: "Europe",
        Montenegro: "Europe",
        Netherlands: "Europe",
        "North Macedonia": "Europe",
        Norway: "Europe",
        Poland: "Europe",
        Portugal: "Europe",
        Romania: "Europe",
        Russia: "Europe",
        "San Marino": "Europe",
        Serbia: "Europe",
        Slovakia: "Europe",
        Slovenia: "Europe",
        Spain: "Europe",
        Sweden: "Europe",
        Switzerland: "Europe",
        Ukraine: "Europe",
        "United Kingdom": "Europe",
        "Vatican City": "Europe",
       
        // Oceania
        Australia: "Oceania",
        Fiji: "Oceania",
        Kiribati: "Oceania",
        "Marshall Islands": "Oceania",
        Micronesia: "Oceania",
        Nauru: "Oceania",
        "New Zealand": "Oceania",
        Palau: "Oceania",
        "Papua New Guinea": "Oceania",
        Samoa: "Oceania",
        "Solomon Islands": "Oceania",
        Tonga: "Oceania",
        Tuvalu: "Oceania",
        Vanuatu: "Oceania",
        // South America
        Argentina: "South America",
        Bolivia: "South America",
        Brazil: "South America",
        Chile: "South America",
        Colombia: "South America",
        Ecuador: "South America",
        Guyana: "South America",
        Paraguay: "South America",
        Peru: "South America",
        Suriname: "South America",
        Uruguay: "South America",
        Venezuela: "South America",
      },
      
      AddressList: [
        {
          id: 1,
          address: "Ayolas 38412, Quilmes Oeste, 1998, Buenos Air...",
        },
        {
          id: 2,
          address: "Ayolas 38412, Quilmes Oeste, 1998, Buenos Air...",
        },
      ],
      AddNewAddressDialog: false,
      CEUsearch: "",
      totalCeuHours: 0,

      shippingAddressRadio: "",
      AddCEUsCalender: false,
      ClinicCheckbox: false,
      AddCEUsDialog: false,
      HomeCheckbox: false,
      publiclyRadio: "",
      editAddressdialog: false,
      invoicedialog: false,
      Membereditdialog: false,
      editexam: false,
      editdialog: false,
      billingeditdialog: false,
      addreseditdialog: false,
      btnloader: false,
      btnloader1: false,
      add_dialog: false,
      dialog: false,
      IsEditing: false,
      Permission: {},
      name: "axel",
      LastName: "Camelatti",
      addressitems: [
        { address: "calle 142,1480,Breaztegui 1448, Areis" },
        { address: "calle 142,1480,Breaztegui 1448, Areis" },
      ],
      notesheaders: [
        { text: "Serial Number", value: "index", sortable: false },
        { text: "Subject", value: "Subject", sortable: false },
        { text: " Date Added", value: "CreatedDate", sortable: false },
        { text: "Added By", value: "CreatedByName", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      notesDataTable: [
        {
          serialnumber: "1",
          notes: "Body talk Fundamentals Extensions",
          dateadded: "12/12/2022",
          addedby: "John veltheim",
        },
        {
          serialnumber: "2",
          notes: "Body talk Fundamentals Extensions and its Extensions ",
          dateadded: "12/12/2022",
          addedby: "John veltheim",
        },
      ],
      credentialsheaders: [
        { text: "Date", value: "date", sortable: false },
        { text: "Exam", value: "exam", sortable: false },
        { text: "Instructor", value: "instructor", sortable: false },
        { text: "Written Score", value: "writtenscore", sortable: false },
        { text: "Practical Score ", value: "politicalscore", sortable: false },
        {
          text: " Credential Earned",
          value: "credentialearn",
          sortable: false,
        },
        { text: "Certificate", value: "downlaods", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      credentialsDataTable: [
        {
          date: "08/13/2022",
          exam: " CBP",
          instructor: "check",
          politicalscore: "56",
          writtenscore: "67",
          credentialearn: "AdvCBP",
        },
        {
          date: "08/13/2022",
          exam: " CBP",
          instructor: "check",
          politicalscore: "56",
          writtenscore: "67",
          credentialearn: "AdvCBP",
        },
      ],
      CEUheaders: [
        { text: "From Date", value: "FromDate", sortable: false },
        { text: "To Date", value: "ToDate", sortable: false },
        { text: "Course", value: "Course", sortable: false },

        { text: "Instructor", value: "Institute", sortable: false },

        { text: "Hours", value: "Hours", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      CEUDataTable: [
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "",
          instructor: "John veltheim",
          monitor: "Yes",
          hregisterdate: "16/12/2021",
          hours: "2",
        },
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "",
          instructor: "John veltheim",
          monitor: "No",
          hregisterdate: "16/12/2021",
          hours: "2",
        },
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "11/02/2017",
          instructor: "John veltheim",
          monitor: "Yes",
          hregisterdate: "16/12/2021",
          hours: "2",
        },
        {
          date: "08/13/2022",
          course: "Body talk Fundamentals Extensions",
          graduate: "11/02/2017",
          instructor: "John veltheim",
          monitor: "No",
          hregisterdate: "16/12/2021",
          hours: "2",
        },
      ],
      specializationsArray: [
        "Work",
        "Home Improvement",
        "Vacation",
        "Food",
        "Drawers",
        "Shopping",
        "Art",
        "Tech",
        "Creative Writing",
      ],

      chk: "calle 142,1480,Breaztegui 1448, Areis",
      chk2: "calle 142,1480,Breaztegui 1448, Areis",
      CEUHours: [
        {
          userName: "Miranda jamieson",
          startDate: "04 Jul, 2011 ",
          endDate: "04 Jul, 2013",
        },
      ],
      item: {
        Membership: "Practitioners",
        Frequency: "Anually",
        Amount: "$99/Year",
        DateMemberShip: "11/11/2021-11/11/2022",
        Data6: "3",
        Data7: "15",
      },
      object: {
        UsertName: "Axel",
        FirstName: "Axel",
        LastName: "Camelitti",
        displaylanguage: "English (US)",
        PhoneNumber: "+11 3333432",
        Timezone: "Pacific Standard (UTC-8)",
        Email: "dw@gmail.com",
        dateRegistered: "11/11/2021",
      },
      object1: {
        Data6: "3",
        Data: "15",
      },
      items: [
        {
          icon: "<v-icon>mdi-truck</v-icon>",
          avatar: "https://picsum.photos/250/300?image=660",
          name: '<span style="font-weight: 700;font-size: 30px;">Alex Camelatti</span> ',
          email: `<span style="color: rgba(34, 34, 34, 0.65);">alex@gmail.com</span> `,
        },
      ],
      LanguageArray: ["English", "Portuguese", "German", "Japanese"],
      tabs: null,
      edit: false,
      courseName: "",
      editCeus: false,
      error: false,
    };
  },
  validations: {
    Addresses: {
      IsPublicallyVisible: {
        required,
      },
      StreetAddress1: {
        required,
      },
      city: {
        // required,
      },
      region: {
        // required,
      },
      IsShippingAddress: {
        required,
      },
      state: {
        // required,
      },
      zipcode: {
        // required,
      },
      country: {
        // required,
      },
    },
    GetPreviewUser: {
      FirstName: {
        required,
        alpha: alphaWithSpacesAndSpecialChars,
      },
      LastName: {
        required,
        alpha: alphaWithSpacesAndSpecialChars,
      },
      Email: {
        required,
        email,
      },
      Phone: {
        // required,
        phoneWithSpecialChars,
        minLength: minLength(7),
        maxLength: maxLength(17),
      },
    },
    updatePassword: {
      NewPassword: {
        required,minLength: minLength(8),
      //   notSameAsOldPassword: not(sameAs("OldPassword"))
      },
      ConfirmNewPassword: {
        required,
        sameAsPassword: sameAs("NewPassword"),
      },
     //  OldPassword: {
     //    required,
     //  },
    },
    note: {
      Subject: {
        required,
      },
      Text: {
        required,
      },
    },
    form: {
      ToDate: {
        required,
      },
      FromDate: {
        required,
      },
      Institute: {
        required,
      },
      Hours: {
        required,
      },
      Course: {
        required,
      },
    },
  },
  methods: {
    async fetchCountries() {
      // Clear all dependent fields first
      this.countries = [];
      this.states = [];
      this.cities = [];
      this.Addresses.country = "";
      this.Addresses.state = "";
      this.Addresses.city = "";
      this.otherCity = "";
      if (!this.Addresses.region){
        return;
      }
      
      try {
        const res = await fetch(
          `https://restcountries.com/v3.1/region/${this.Addresses.region}`
        );
        const data = await res.json();
        this.countries = data.map((c) => c.name.common).filter((name) => name !== "Jersey").sort();
        
      } catch (error) {
        console.error("Failed to fetch countries:", error);
        this.countries = [];
      }
    },
    async fetchStates() {
      // Clear dependent fields first
      this.states = [];
      this.cities = [];
      this.Addresses.state = "";
      this.Addresses.city = "";
      this.otherCity = "";
      if (!this.Addresses.country) {
        return;
      }
      // Manually inject Jersey under United Kingdom
      if (this.Addresses.country === "United Kingdom") {
        const manualStates = [
          "England",
          "Scotland",
          "Wales",
          "Northern Ireland",
          "Jersey",
        ];
        this.states = manualStates.sort();
        return;
      }

      try {
        const response = await fetch("https://countriesnow.space/api/v0.1/countries/states", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ country: this.Addresses.country }),
        });

        const result = await response.json();

        if (result?.data?.states?.length) {
          this.states = result.data.states.map((s) => s.name);
          
        } else {
          this.states = [];
          
        }
      } catch (e) {
        console.error("Failed to fetch states:", e);
        this.states = [];
        
      }
    },
    async fetchCities() {
      // Clear dependent field first
      this.cities = [];
      this.Addresses.city = "";
      this.otherCity = "";
      if (!this.Addresses.state || !this.Addresses.country) {
        return;
      }

      // Manual city/parish additions
      const manualCities = {
        Canada: {
          Saskatchewan: ["Wymark"],
          "New Brunswick": ["Woodstock"],
        },
        "United Kingdom": {
          Jersey: [
            "Grouville",
            "St. Brelade",
            "St. Clement",
            "St. Helier",
            "St. John",
            "St. Lawrence",
            "St. Martin",
            "St. Mary",
            "St. Ouen",
            "St. Peter",
            "St. Saviour",
            "Trinity"
          ]
        }
      };

      const extraCities = manualCities[this.Addresses.country]?.[this.Addresses.state] || [];

      try {
        const response = await fetch("https://countriesnow.space/api/v0.1/countries/state/cities", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            country: this.Addresses.country,
            state: this.Addresses.state,
          }),
        });

        const result = await response.json();
        const apiCities = result?.data?.length ? result.data : [];
        // Merge manual and fetched cities
        this.cities = [...new Set([...extraCities, ...apiCities])].sort();

      } catch (e) {
        console.error("Failed to fetch cities:", e);
        this.cities = [];
      }
    },
    customFilter(item, queryText, itemText) {
      const text = itemText.toLowerCase();
      const searchText = queryText.toLowerCase();
      return text.includes(searchText) || item.timezone.toLowerCase().includes(searchText);
    },
   
    setDefaultImage(event) {
      event.target.src = 'https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png'
    },
    calculateDates(startDateStr) {
      let startDate = new Date(startDateStr);
      let currentDate = new Date();

      while (startDate.getFullYear() + 2 <= currentDate.getFullYear()) {
        startDate.setFullYear(startDate.getFullYear() + 2);
      }

      // Ensure startDate doesn't go beyond the current period
      if (currentDate < startDate) {
        startDate.setFullYear(startDate.getFullYear() - 2);
      }

      const formattedDate = `${startDate.getFullYear()}-${String(
        startDate.getMonth() + 1
      ).padStart(2, "0")}-${String(startDate.getDate()).padStart(2, "0")}`;

      return formattedDate;
    },
    openBioPage() {
      // const url = `http://iba.rootpointers.net/profile/bio?userId=${this.GetPreviewUser.Id}`;
      const url = `https://new.bodytalksystem.com/practitioner/practitionerdetail/${this.GetPreviewUser.Id}`;
      window.open(url, "_blank");
    },
    nextPeriod() {
      this.startDate = this.endDate;
      this.endDate = this.addAndSubYearsToDate(this.startDate, 2, "add");
      this.getUserCEUs.result = [];
      this.fetchCeusData();
    },
    previousPeriod() {
      this.endDate = this.startDate;
      this.startDate = this.addAndSubYearsToDate(this.startDate, 2, "sub");
      this.getUserCEUs.result = [];
      this.fetchCeusData();
    },
    addAndSubYearsToDate(dateStr, yearsToAddAndSub, name) {
      let [year, month, day] = dateStr.split("-");
      if (name == "add") {
        year = parseInt(year, 10) + yearsToAddAndSub;
      }
      if (name == "sub") {
        year = parseInt(year, 10) - yearsToAddAndSub;
      }
      const newDateStr = `${year}-${month}-${day}`;

      return newDateStr;
    },
    convertDate(dateStr) {
      if (!dateStr) {
        return;
      }
      const [year, month, day] = dateStr?.split("-");
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const monthAbbr = monthNames[parseInt(month, 10) - 1];
      const formattedDate = `${day} ${monthAbbr?.toUpperCase()}, ${year}`;

      return formattedDate;
    },
    OpenPasswordDialog() {
      this.BtnLoader = false;
      this.forgetPasswordDialog = true;
    //   this.updatePassword.OldPassword = "";
      this.updatePassword.NewPassword = "";
      this.updatePassword.ConfirmNewPassword = "";
    },
    getErrorMessageforPassword(fieldName) {
      const errorMessages = {
        NewPassword: {
          required: "New password is required",
          minLength: "Password should be a minimum of 8 characters.",
        //   notSameAsOldPassword: "New password cannot be the same as the old password",
        },
        ConfirmNewPassword: {
          required: "Confirm new password is required",
          sameAsPassword: "Password are not same",
        },
      //   OldPassword: {
      //     required: "Old password is required",
       //  },
      };
      const errorField = this.$v.updatePassword[fieldName];
      if (!errorField.$dirty) return null;
      const errors = [];
      Object.keys(errorField.$params).forEach((param) => {
        if (!errorField[param]) {
          errors.push(errorMessages[fieldName][param]);
        }
      });

      return errors.length ? errors[0] : null;
    },
    getErrorMessage(fieldName) {
      const errorMessages = {
        FirstName: {
          required: "First name is required",
          alpha: "Only alphabetic characters allowed",
        },
        LastName: {
          required: "Last name is required",
          alpha: "Only alphabetic characters allowed",
        },
        Email: {
          required: "Email is required",
          email: "Invalid email",
        },
        Phone: {
          // required: "Phone number is required",
          phoneWithSpecialChars: "Only numeric characters allowed",
          minLength: "Phone number should be minimum of 7 digits",
          maxLength: "Phone number should be maximum of 12 digits",
        },
      };

      const errorField = this.$v.GetPreviewUser[fieldName];
      if (!errorField.$dirty) return null;
      const errors = [];
      Object.keys(errorField.$params).forEach((param) => {
        if (!errorField[param]) {
          errors.push(errorMessages[fieldName][param]);
        }
      });

      return errors.length ? errors[0] : null;
    },
    editCeusDialogOpen(ceusData) {
      this.editCeus = true;
      this.form.Id = ceusData.Id;
      (this.form.Date = ceusData.Date?.split("T")[0]),
        (this.form.Institute = ceusData.Institute),
        (this.form.Hours = ceusData.Hours),
        (this.form.Course = ceusData.Course),
        (this.form.UserId = ceusData.UserId),
        (this.form.CreatedBy = ceusData.CreatedBy),
        (this.courseName = ceusData.CourseName);
      this.AddCEUsDialog = true;
    },
    fetchCourses() {
      const obj = {
        page: 1,
        pageSize: "all",
        search: "",
        filters: "",
      };
      this.$store.dispatch("GetCourse", obj);
    },
    ViewNotesDialogOpen(data) {
      this.ViewNotesDialog = true;
      this.viewNote.Subject = data.Subject;
      this.viewNote.Text = data.Text;
    },
    AddNotesDialogOpen() {
      this.AddNotesDialog = true;
      this.note.Subject = "";
      this.note.Text = "";
      this.edit = false;
    },
    editDialogOpen(data) {
      this.edit = true;
      this.note.Subject = data.Subject;
      this.note.Text = data.Text;
      this.note.CreatedBy = data.CreatedByUserId;
      this.note.UserId = data.UserId;
      this.note.Id = data.Id;
      this.AddNotesDialog = true;
    },
    deleteItem(item) {
      this.$store.dispatch("DeleteUserNotesById", item.Id).then(() => {
        this.$swal.fire({
          icon: "success",
          title: "Note Deleted successfuly   ",
          showConfirmButton: false,
          timer: 3000,
        });
        this.fetchData();
      });
    },
    formatDate(date) {
      const inputDate = new Date(date);
      const formattedDate = inputDate.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
      return formattedDate;
    },
    async fetchData() {
      this.loader = true;
      const obj = {
        id: this.GetPreviewUser.Id,
      };
      await this.$store.dispatch("GetMembershipByUserId", obj);
      await this.$store.dispatch("GetAllUserNotesByUserId", obj);
    },
    SubmitAddCEUs() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.form.UserId = this.GetPreviewUser.Id;
      this.form.CreatedBy = this.GetLoggedInUser.Id;
      this.btnloader = true;
      this.$store.dispatch("AddOrUpdateUserCEUs", this.form).then(() => {
        this.btnloader = false;
        this.AddCEUsDialog = false;
        this.$swal.fire({
          icon: "success",
          title: this.editCeus
            ? "CEUs have been Edit "
            : "CEUs have been added ",
          showConfirmButton: false,
          timer: 3000,
        });
        this.form.Id = 0;
          (this.form.Date = ""),
          (this.form.ToDate = ""),
          (this.form.FromDate = ""),
          (this.form.Institute = ""),
          (this.form.Hours = null),
          (this.form.Course = null),
          (this.form.UserId = 0),
          (this.form.CreatedBy = 0),
          (this.courseName = "");
        this.$v.form.$reset();
        this.fetchCeusData();
      });
    },
    deleteCeus(item) {
      this.$store.dispatch("DeleteUserCEUs", item.Id).then(() => {
        this.$swal.fire({
          icon: "success",
          title: "CEUs Delete successfuly   ",
          showConfirmButton: false,
          timer: 3000,
        });
        this.fetchCeusData();
      });
    },
    fetchCeusData() {
      this.btnloader = true;
      this.$store
        .dispatch("GetUserCEUs", {
          id: this.GetPreviewUser.Id,
          search: this.CEUsearch,
          startDate: this.startDate,
          endDate: this.endDate,
        })
        .then(() => {
          this.btnloader = false;
        });
    },
    SetImage(file) {
      this.GetPreviewUser.ProfileImageFile = file;
    },
    closeResetPasswordDialog(){
      this.$v.updatePassword.$reset()
      this.forgetPasswordDialog = false
    },
    ResetPassowrd() {
      
      this.$v.updatePassword.$touch();
      var changingpassword = {
       //  CurrentPassword: this.updatePassword.OldPassword,
        NewPassword: this.updatePassword.ConfirmNewPassword,
        Email: this.GetPreviewUser?.Email,
      };
      if (this.$v.updatePassword.$invalid) {
        return
      } else {
        this.BtnLoader = true;
        this.$store.dispatch("UpdatePassword", changingpassword).then((res) => {
          console.log(res);
          this.BtnLoader = false;
          this.forgetPasswordDialog = false;
         //    (this.updatePassword.OldPassword = ""),
            (this.updatePassword.NewPassword = ""),
            (this.updatePassword.ConfirmNewPassword = ""),
            this.$swal.fire({
              icon: "success",
              title: res.data.Message == "Password Updated Successfully" ? "Your Password has been Updated" : res.data.Message,
              showConfirmButton: false,
              timer: 3000,
            });
            this.$v.updatePassword.$reset()
        });
      }
    },
    OpenDeleteDialog(id) {
      this.deleteAddressID = id;
      this.DeleteDialog = true;
    },
    DeleteAddress() {
      this.btnloader = true;
      this.$store.dispatch("DeleteAddress", this.deleteAddressID).then(() => {
        this.$store.dispatch("AllAddress", this.GetPreviewUser.Id);
        this.$swal.fire({
          icon: "success",
          title: "Your Address has been Deleted ",
          showConfirmButton: false,
          timer: 3000,
        });
        this.DeleteDialog = false;
        this.btnloader = false;
      });
    },
    AddNewNotes() {
      this.$v.note.$touch();
      if (this.$v.note.$invalid) {
        return;
      }
      if (this.edit == false) {
        this.note.CreatedBy = this.GetLoggedInUser.Id;
        this.note.UserId = this.GetPreviewUser.Id;
      }
      this.$store.dispatch("AddOrUpdateNotes", this.note).then(() => {
        this.note.Id = 0;
        this.AddNotesDialog = false;
        this.$swal.fire({
          icon: "success",
          title:
            this.edit == true
              ? "Note Edited successfully"
              : "Note added successfuly   ",
          showConfirmButton: false,
          timer: 3000,
        });
        this.edit = false;
        this.$v.note.$reset();
        this.fetchData();
      });
    },
    async EditAddress(item) {
      if (item.Id) {
        this.EditAddressDialog = true;
        this.Addresses.StreetAddress1 = item.StreetAddress1;
        this.Addresses.StreetAddress2 = item.StreetAddress2;
        // First set the region and fetch countries
        this.Addresses.region = item.Region;
        await this.fetchCountries();
        
        // Then set the country and fetch states
        this.Addresses.country = item.Country;
        await this.fetchStates();
        
        // Then set the state and fetch cities
        this.Addresses.state = item.State;
        await this.fetchCities();
        // Handle the city field - check if it's in the cities list
        if (item.City == '' || this.cities.includes(item.City)) {
          this.Addresses.city = item.City;
          this.otherCity = "";
        } else {
          this.Addresses.city = "Other";
          this.otherCity = item.City;
        }
        this.Addresses.state = item.State;
        this.Addresses.zipcode = item.Zipcode;
        this.Addresses.country = item.Country;
        this.Addresses.region = item.Region;
        this.Addresses.IsPublicallyVisible = item.IsPublicallyVisible;
        this.Addresses.IsClinicAddress = item.IsClinicAddress;
        this.Addresses.IsHomeAddress = item.IsHomeAddress;
        this.Addresses.IsShippingAddress = item.IsShippingAddress;
        this.Addresses.Id = item.Id;
      }
      this.EditAddressDialog = true;
      this.btnloader = false;
    },
    updateAddress() {
      this.$v.Addresses.$touch();
      if (this.$v.Addresses.$invalid) {
        return;
      }
      this.btnloader = true;
      this.Addresses.UserId = this.GetPreviewUser.Id;
      this.Addresses.city = this.Addresses.city == 'Other' ? this.otherCity : this.Addresses.city;
      this.$store.dispatch("EditAddress", this.Addresses).then(() => {
        this.EditAddressDialog = false;
        this.btnloader = false;
        this.$store.dispatch("AllAddress", this.GetPreviewUser.Id);
        this.$swal.fire({
          icon: "success",
          title: "Your Address has been Updated ",
          showConfirmButton: false,
          timer: 3000,
        });
        this.Addresses.StreetAddress1 = "";
        this.Addresses.StreetAddress2 = "";
        this.Addresses.city = "";
        this.Addresses.state = "";
        this.Addresses.zipcode = "";
        this.Addresses.country = "";
        this.Addresses.region = null;
        this.Addresses.IsPublicallyVisible = null;
        this.Addresses.IsClinicAddress = false;
        this.Addresses.IsHomeAddress = false;
        this.Addresses.IsShippingAddress = null;
        this.$v.Addresses.$reset();
      });
    },
    AddAddress() {
      this.$v.Addresses.$touch();
      if (this.$v.Addresses.$invalid) {
        return;
      }
      this.btnloader = true;
      this.Addresses.UserId = this.GetPreviewUser.Id;
      this.Addresses.city = this.Addresses.city == 'Other' ? this.otherCity : this.Addresses.city;
      this.$store.dispatch("AddAddress", this.Addresses).then(() => {
        this.AddNewAddressDialog = false;
        this.btnloader = false;
        this.$store.dispatch("AllAddress", this.GetPreviewUser.Id);
        this.$swal.fire({
          icon: "success",
          title: "Your Address has been Added",
          showConfirmButton: false,
          timer: 3000,
        });
        this.Addresses.StreetAddress1 = "";
        this.Addresses.StreetAddress2 = "";
        this.Addresses.city = "";
        this.Addresses.state = "";
        this.Addresses.zipcode = "";
        this.Addresses.country = "";
        this.Addresses.region = "";
        this.countries = [];
        this.states = [];
        this.cities = [];
        this.Addresses.IsPublicallyVisible = null;
        this.Addresses.IsClinicAddress = false;
        this.Addresses.IsHomeAddress = false;
        this.Addresses.IsShippingAddress = null;
        this.$v.Addresses.$reset();
      });
    },
    
    close() {
      this.editdialog = false;
      this.editexam = false;
      this.addreseditdialog = false;
      this.add_dialog = false;
      this.snackbar = true;
    },
    closeAddCEU() {
      this.AddCEUsDialog = false;
      (this.form.ToDate = ""),
      (this.form.FromDate = ""),
      (this.form.Institute = ""),
      (this.form.Hours = null),
      (this.form.Course = null)
      this.$v.$reset();
    },
    Update() {
      this.$v.GetPreviewUser.$touch();
      if (this.$v.GetPreviewUser.$error) {
        return;
      }
      this.IsEditing = false;
      this.GetPreviewUser.Specializations = this.specializationsArray.toString();
      var form = new FormData();
      form.append("FirstName", this.GetPreviewUser.FirstName);
      form.append("LastName", this.GetPreviewUser.LastName);
      form.append("AlternateName", this.GetPreviewUser.AlternateName == null || this.GetPreviewUser.AlternateName == "null" ? "" : this.GetPreviewUser.AlternateName);
      // form.append("displaylanguage", this.GetPreviewUser.displaylanguage);
      form.append("Id", this.GetPreviewUser.Id.toString());
      form.append("Phone", this.GetPreviewUser.Phone == null || this.GetPreviewUser.Phone == "null" ? "" : this.GetPreviewUser.Phone);
      form.append("ProfileImageFile", this.GetPreviewUser.ProfileImageFile);
      form.append("WebpageURL", this.GetPreviewUser.WebpageURL == null || this.GetPreviewUser.WebpageURL == "null" ? "" : this.GetPreviewUser.WebpageURL);
      form.append("Specializations", this.GetPreviewUser.Specializations);
      form.append("IntroDescription", this.GetPreviewUser.IntroDescription == null || this.GetPreviewUser.IntroDescription == "null" ? "" : this.GetPreviewUser.IntroDescription);
      form.append("Timezone", this.GetPreviewUser.Timezone);
      form.append("Language", this.GetPreviewUser.Language);
      form.append("Bio", this.GetPreviewUser.Bio == null || this.GetPreviewUser.Bio == "null" ? "" : this.GetPreviewUser.Bio);
      form.append("Country", this.GetPreviewUser.Country == null || this.GetPreviewUser.Country == "null" ? "" : this.GetPreviewUser.Country);
      form.append("Email", this.GetPreviewUser.Email);
      this.$store.dispatch("UpdateUser", form).then(() => {
        this.$store
          .dispatch("GetPreviewUser", this.GetPreviewUser.Id)
          .then(() => {
            this.$nextTick(() => {
              this.GetPreviewUser = this.GetUserWeb;
              this.specializationsArray =
                this.GetPreviewUser.Specializations != null
                  ? this.GetPreviewUser.Specializations.split(",")
                  : [];
            });
          });
      });
    },
    cancelprofile() {
      this.$store.dispatch("GetPreviewUser", this.GetPreviewUser.Id).then(() => {
        this.$nextTick(() => {
          this.GetPreviewUser = this.GetUserWeb;
          this.specializationsArray =
            this.GetPreviewUser.Specializations != null
              ? this.GetPreviewUser.Specializations.split(",")
              : [];
        });
      });
      this.IsEditing = false;
    },
    closeDialog() {
      this.add_dialog = false;
      this.value = false;
      this.Addresses.StreetAddress1 = "";
      this.Addresses.StreetAddress2 = "";
      this.Addresses.city = "";
      this.Addresses.state = "";
      this.Addresses.zipcode = "";
      this.Addresses.country = "";
      this.countries = [];
      this.states = [];
      this.cities = [];
      this.Addresses.region = "";
      this.EditAddressDialog = false;
      this.AddNewAddressDialog = false;
      this.Addresses.IsPublicallyVisible = null;
      this.Addresses.IsClinicAddress = false;
      this.Addresses.IsHomeAddress = false;
      this.Addresses.IsShippingAddress = null;
      this.$v.Addresses.$reset();
    },
    DdialogClose() {
      this.dialog = false;
      this.Deletesnackbar = true;
    },
    snackbarClose() {
      // this.snackbar = false;
      this.Deletesnackbar = false;
    },
    openadddialog() {
      this.add_dialog = true;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.add_dialog = false;
        this.editdialog = false;
        this.editexam = false;
        this.addreseditdialog = false;
        this.addreseditdialog = false;
        this.Membereditdialog = false;
        this.billingeditdialog = false;
        this.Memberinfoeditdialog = false;
        this.editAddressdialog = false;
        this.btnloader = false;
      }, 2000);
    },
  },
};
</script>
<style scoped>
.profile_h1 {
  font-family: "Nunito Sans";
  font-size: 30px;
  font-weight: 700;
}
.profile_span {
  font-family: "Nunito Sans";
  font-size: 24px;
  font-weight: 400;
  color: rgba(34, 34, 34, 0.65);
}
.tabs_slider {
  color: #1884cd;
  font-weight: 800;
  font-size: 16px;
  line-height: 21px;
  border-bottom: 2px solid #e1e4e7;
  flex: 0 0 0px;
  min-width: 0px;
}
.style_txt_hh1 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: rgba(34, 34, 34, 0.7);
}
.style_txt_hh2 {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: #222222;
}
.devider_style {
  opacity: 0.1;
  border: 1px solid #000000;
}
.text_transform {
  text-transform: none;
}
.stying_text {
  text-transform: none !important;
  border: 1px solid #d2e5fc;
}
.text-center {
  text-align: center !important;
}
.gmap-autocomplete {
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  outline: none;
  border-radius: 0;
  background: transparent;
  height: 40px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.gmap-autocomplete:focus {
  border-bottom: 2px solid #1976d2;
}
.error-message {
  color: red;
  font-size: 12px;
  margin-top: 2px;
  margin-bottom: 4px;
}
</style>
